// src/actions/review-setting.js

import api from './gamba-api'
import config from '../config'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_REVIEW_SETTING = "FETCH_REVIEW_SETTING"
export const FETCH_REVIEW_SETTING_REQUESTED = "FETCH_REVIEW_SETTING_REQUESTED"
export const FETCH_REVIEW_SETTING_COMPLETED = "FETCH_REVIEW_SETTING_COMPLETED"
export const FETCH_REVIEW_SETTING_FAILED = "FETCH_REVIEW_SETTING_FAILED"

export function fetchReviewSettingRequested() {
  return {
    type: FETCH_REVIEW_SETTING_REQUESTED
  }
}

export function fetchReviewSetting() {
  return function(dispatch) {
    dispatch(fetchReviewSettingRequested())
    return api.get(`/account/review_setting`)
        .then((results)=> {
          dispatch(fetchReviewSettingCompleted(results))
        })
        .catch((error)=> {
          console.log(error)
          Promise.all([
            dispatch(fetchReviewSettingFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchReviewSettingCompleted(results) {
  return {
    type: FETCH_REVIEW_SETTING_COMPLETED,
    results
  }
}

export function fetchReviewSettingFailed(error) {
  return {
    type: FETCH_REVIEW_SETTING_FAILED,
    error,
  }
}


// export const UPDATE_REVIEW_SETTING = "UPDATE_REVIEW_SETTING"
// export const UPDATE_REVIEW_SETTING_REQUESTED = "UPDATE_REVIEW_SETTING_REQUESTED"
// export const UPDATE_REVIEW_SETTING_COMPLETED = "UPDATE_REVIEW_SETTING_COMPLETED"
// export const UPDATE_REVIEW_SETTING_FAILED = "UPDATE_REVIEW_SETTING_FAILED"

// export function updateReviewSettingRequested() {
//   return {
//     type: UPDATE_REVIEW_SETTING_REQUESTED
//   }
// }

// export function updateReviewSetting() {
//   return function(dispatch) {
//     dispatch(updateReviewSettingRequested())
//     return api.post(`/review_settting`, user_id)
//         .then((results)=> {
//           dispatch(updateReviewSettingCompleted(results))
//         })
//         .catch((error)=> {
//           Promise.all([
//             dispatch(updateReviewSettingFailed(user_id, error)),
//             dispatch(emitAlertMessage(error, 'error'))
//           ])
//         })
//   }
// }

// export function updateReviewSettingCompleted(results) {
//   return {
//     type: UPDATE_REVIEW_SETTING_COMPLETED,
//     results
//   }
// }

// export function updateReviewSettingFailed() {
//   return {
//     type: UPDATE_REVIEW_SETTING_FAILED,
//     error,
//   }
// }


// WEBPACK FOOTER //
// ./src/actions/review-setting.js